<template>
    <v-container fluid>
        <v-toolbar class="elevation-1">
            <v-btn
                @click="fab = !fab"
                :color="fab_color"
                dark
                fab
                class="mr-2"
                small
                elevation="1"
            >
                <v-icon size="18" v-if="!fab">mdi-filter-variant</v-icon>
                <v-icon size="18" v-else>close</v-icon>
            </v-btn>
            <v-slide-x-transition>
                <div v-show="fab" style="position: fixed; margin-left: 50px">
                    <v-btn
                        v-for="(day, i) in truck.week"
                        :key="i"
                        @click.stop="filterOn(i)"
                        :color="dayStatus == i ? 'primary' : '#999'"
                        class="mx-1"
                        rounded
                        small
                        dark
                    >
                        {{
                            $vuetify.breakpoint.smAndDown
                                ? $t("message." + day.day)[0]
                                : $vuetify.breakpoint.lgAndUp
                                ? $t("message." + day.day)
                                : $t("message." + day.day).slice(0, 3)
                        }}
                    </v-btn>
                </div>
            </v-slide-x-transition>
            <v-toolbar-title v-if="!fab" class="ml-2">
                {{ $t("message.Recurring_Registrations") }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                v-if="
                    $can('create', 'recurringregistrations') &&
                    (!$vuetify.breakpoint.smAndDown || !fab)
                "
                @click="newItem()"
                color="primary"
                class="ml-4"
            >
                {{ $t("message.registerButton") }}
            </v-btn>

            <v-dialog
                @keydown.esc="close()"
                v-model="dialog"
                max-width="800"
                persistent
                scrollable
                :transition="
                    $vuetify.breakpoint.smAndDown
                        ? 'slide-y-transition'
                        : 'scale-transition'
                "
                :fullscreen="$vuetify.breakpoint.smAndDown"
            >
                <v-card class="register-card">
                    <v-card-title>
                        <span>{{ formTitle }}</span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="close">
                            <v-icon medium>cancel</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="form">
                            <v-container>
                                <v-row justify="center" dense>
                                    <v-col cols="12" md="6">
                                        <v-text-field
                                            outlined
                                            filled
                                            dense
                                            disabled
                                            :value="truck.company_name"
                                            :label="formHeaders[0].text"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field
                                            outlined
                                            dense
                                            spellcheck="false"
                                            v-model="truck.notification_email"
                                            :rules="[
                                                rules.required,
                                                rules.max63Chars,
                                                rules.email,
                                            ]"
                                        >
                                            <template v-slot:label>
                                                {{ formHeaders[1].text }}
                                                <strong style="color: red"
                                                    >*</strong
                                                >
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field
                                            spellcheck="false"
                                            outlined
                                            dense
                                            v-model="truck.reference"
                                            :rules="[
                                                rules.required,
                                                rules.max127Chars,
                                            ]"
                                        >
                                            <template v-slot:label>
                                                {{ formHeaders[2].text }}
                                                <strong style="color: red"
                                                    >*</strong
                                                >
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field
                                            spellcheck="false"
                                            outlined
                                            dense
                                            v-model="truck.contact"
                                            :label="formHeaders[3].text"
                                            :rules="[
                                                rules.max63Chars,
                                                rules.contactAllowedCharacters,
                                            ]"
                                        />
                                    </v-col>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                            align="center"
                                            class="my-4"
                                        >
                                            <v-btn
                                                v-for="i in truck.week"
                                                :key="i.day"
                                                @click="addDay(i)"
                                                rounded
                                                class="week-btn elevation-2 ma-1"
                                                :class="{
                                                    'week-btn-pressed': i.value,
                                                }"
                                            >
                                                {{
                                                    $t(
                                                        "message." + i.day
                                                    ).slice(0, 3)
                                                }}
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-col cols="12" md="6">
                                        <v-dialog
                                            v-model="clock.toggleStart"
                                            width="300px"
                                        >
                                            <template v-slot:activator="{}">
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    v-model="clock.start"
                                                    :rules="[rules.required]"
                                                    append-icon="access_time"
                                                    @click:append="
                                                        toggleClockStart()
                                                    "
                                                    type="time"
                                                    class="v-text-field-outlined-time"
                                                >
                                                    <template v-slot:label>
                                                        {{
                                                            formHeaders[5].text
                                                        }}
                                                        <strong
                                                            style="color: red"
                                                            >*</strong
                                                        >
                                                    </template>
                                                </v-text-field>
                                            </template>

                                            <v-time-picker
                                                ref="timerStart"
                                                v-model="clock.start"
                                                width="300px"
                                                format="24hr"
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    @click="toggleClockStart()"
                                                    >OK</v-btn
                                                >
                                            </v-time-picker>
                                        </v-dialog>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-dialog
                                            v-model="clock.toggleEnd"
                                            width="300px"
                                        >
                                            <template v-slot:activator="{}">
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    v-model="clock.end"
                                                    :rules="[rules.required]"
                                                    append-icon="access_time"
                                                    @click:append="
                                                        toggleClockEnd()
                                                    "
                                                    type="time"
                                                    class="v-text-field-outlined-time"
                                                >
                                                    <template v-slot:label>
                                                        {{
                                                            formHeaders[6].text
                                                        }}
                                                        <strong
                                                            style="color: red"
                                                            >*</strong
                                                        >
                                                    </template>
                                                </v-text-field>
                                            </template>

                                            <v-time-picker
                                                ref="timerEnd"
                                                v-model="clock.end"
                                                width="300px"
                                                format="24hr"
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    @click="toggleClockEnd()"
                                                    >OK</v-btn
                                                >
                                            </v-time-picker>
                                        </v-dialog>
                                    </v-col>

                                    <v-col cols="12" md="6" class="pt-0">
                                        <v-text-field
                                            outlined
                                            dense
                                            :value="truck.transp_name"
                                            @input="
                                                v =>
                                                    (truck.transp_name =
                                                        v
                                                            .charAt(0)
                                                            .toUpperCase() +
                                                        v.slice(1))
                                            "
                                            autocomplete="off"
                                            :rules="[
                                                rules.required,
                                                rules.max44Chars,
                                                rules.firstChar,
                                                rules.transporterAllowedCharacters,
                                            ]"
                                        >
                                            <template v-slot:label>
                                                {{ $t("message.Transporter") }}
                                                <strong style="color: red"
                                                    >*</strong
                                                >
                                            </template>
                                        </v-text-field>
                                    </v-col>

                                    <!-- Type -->
                                    <v-col cols="12" md="6" class="pt-0">
                                        <v-select
                                            outlined
                                            dense
                                            v-model="truck.type"
                                            :items="types"
                                            item-text="text"
                                            item-value="value"
                                            type="number"
                                            :rules="[rules.required]"
                                        >
                                            <template v-slot:label>
                                                {{ formHeaders[8].text }}
                                                <strong style="color: red"
                                                    >*</strong
                                                >
                                            </template>
                                        </v-select>
                                    </v-col>

                                    <v-col cols="12" md12>
                                        <v-textarea
                                            rows="2"
                                            auto-grow
                                            outlined
                                            dense
                                            v-model="truck.remarks_customer"
                                            :label="formHeaders[9].text"
                                            :rules="[rules.max127Chars]"
                                        />
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="list-button" @click="save">
                            <v-icon
                                class="pr-2"
                                color="success"
                                style="vertical-align: middle"
                                >save</v-icon
                            >
                            {{ $t("message.SaveButton") }}
                        </v-btn>
                        <v-btn class="list-button" @click="close">
                            <v-icon
                                class="pr-2"
                                color="error"
                                style="vertical-align: middle"
                                >cancel</v-icon
                            >
                            {{ $t("message.CancelButton") }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-toolbar>
        <v-data-table
            :headers="tableHeaders"
            :loading="$store.getters.getLoading"
            :items="items"
            :search="$store.getters.getSearch"
            class="elevation-5"
            height="calc(100vh - 220px - 40px)"
            fixed-header
            :items-per-page="35"
            mobile-breakpoint="0"
            :footer-props="$store.getters.getFooterProps"
            :custom-filter="customSearch"
        >
            <template slot="item" slot-scope="props">
                <tr
                    :style="
                        $can('update', 'recurringregistrations')
                            ? 'cursor:pointer'
                            : ''
                    "
                    @click="
                        $can('update', 'recurringregistrations')
                            ? editItem(props.item)
                            : ''
                    "
                    class="text-no-wrap"
                >
                    <td>{{ rec_days(props.item) }}</td>

                    <td>
                        {{ props.item.arrival_time_from }} -
                        {{ props.item.arrival_time_to }}
                    </td>

                    <td>
                        {{ types.find(x => x.value === props.item.type).text }}
                    </td>

                    <td>{{ props.item.transp_name }}</td>

                    <td>{{ props.item.reference }}</td>

                    <td>
                        <v-btn
                            v-if="$can('delete', 'recurringregistrations')"
                            class="caption font-weight-black"
                            small
                            @click.stop="deleteItem(props.item)"
                        >
                            <v-icon class="pr-2" color="error">delete</v-icon>
                            {{ $t("message.DeleteButton") }}
                        </v-btn>
                    </td>
                </tr>
            </template>
            <v-alert
                slot="no-data"
                dense
                :value="true"
                class="body-1 my-3 text-capitalize"
                color="warning"
                icon="warning"
                >{{ $t("message.NoResults") }} {{ get_day_label }}</v-alert
            >
            <v-alert
                slot="no-results"
                dense
                :value="true"
                class="body-1 my-3"
                color="error"
                icon="warning"
            >
                {{ $t("message.YourSearch") }} "{{ $store.getters.getSearch }}"
                {{ $t("message.NoResults") }}
            </v-alert>
        </v-data-table>
    </v-container>
</template>

<script>
export default {
    data: () => ({
        fab: true,
        firstCharCorrect: true,
        isLoading: false,
        lookup: "",
        defaultTruck: {
            company_name: "",
            notification_email: "",
            contact: "",
            arrival_time_from: "",
            arrival_time_to: "",
            type: "",
            reference: "",
            transp_name: "",
            remarks_customer: "",
            week: [
                { day: "Monday", value: false },
                { day: "Tuesday", value: false },
                { day: "Wednesday", value: false },
                { day: "Thursday", value: false },
                { day: "Friday", value: false },
                { day: "Saturday", value: false },
                { day: "Sunday", value: false },
            ],
        },
        truck: {
            company_name: "",
            notification_email: "",
            contact: "",
            arrival_time_from: "",
            arrival_time_to: "",
            type: "",
            reference: "",
            transp_name: "",
            remarks_customer: "",
            week: [
                { day: "Monday", value: false },
                { day: "Tuesday", value: false },
                { day: "Wednesday", value: false },
                { day: "Thursday", value: false },
                { day: "Friday", value: false },
                { day: "Saturday", value: false },
                { day: "Sunday", value: false },
            ],
        },
        types: [
            { text: "Load", value: 5 },
            { text: "Unload", value: 10 },
            { text: "Load & Unload", value: 15 },
        ],
        clock: {
            toggleStart: false,
            toggleEnd: false,
            start: "09:00",
            end: "17:00",
        },
        editedIndex: -1,
        dialog: false,
        apiDays: [
            "on_monday",
            "on_tuesday",
            "on_wednesday",
            "on_thursday",
            "on_friday",
            "on_saturday",
            "on_sunday",
        ],
        dayStatus: null,
        changed: false,
    }),
    mounted() {
        this.$store.dispatch("processRecRegistrations");
        this.$store.dispatch("processTransporter");

        this.initialize();
    },
    methods: {
        initialize() {
            this.defaultTruck.company_name =
                this.$store.getters.getLoggedUserCompany;
            this.defaultTruck.notification_email =
                this.$store.getters.getLoggedUserEmail;
            this.defaultTruck.contact = this.$store.getters.getLoggedUserName;
        },
        customSearch(value, search, item) {
            return Object.values(item).some(
                v => v && v.toString().toLowerCase().includes(search)
            );
        },
        setFocus() {
            setTimeout(() => {
                this.$refs.form.$children[1].focus();
            }, 0);
        },
        filterOn(index) {
            this.dayStatus = this.dayStatus !== index ? index : null;
        },
        async addTransporter() {
            this.truck.transp_name = this.lookup;
            this.isLoading = true;
            await this.$store.dispatch("addTransporter", {
                name: this.truck.transp_name,
            });
            this.isLoading = false;
            this.$refs.autocomp.lazySearch = this.truck.transp_name;
            this.$refs.autocomp.isMenuActive = false;
        },
        editItem(item) {
            this.editedIndex =
                this.$store.getters.getRecRegistrations.indexOf(item);
            Object.assign(this.truck, this.defaultTruck, item);

            // Type map with API
            // this.truck.type = this.types[this.truck.type / 5 - 1];

            // Week map with API
            for (let i = 0; i < 7; i += 1) {
                this.truck.week[i].value = this.truck[this.apiDays[i]];
            }

            // Update clocks
            this.clock.start = this.truck.arrival_time_from;
            this.clock.end = this.truck.arrival_time_to;

            // Open form dialog
            this.dialog = true;
        },

        deleteItem(item) {
            this.$store.commit("popUp", {
                type: "deleteRecRegistrations",
                id: item.template_id,
            });
        },

        close() {
            if (
                this.changed &&
                // TODO: USE Alert component instaed
                // eslint-disable-next-line no-restricted-globals, no-alert
                !confirm("Are you sure ? Any unsaved changes will be lost.")
            ) {
                return;
            }

            // Close form
            this.dialog = false;
        },
        newItem() {
            // Clear and assign defaults
            this.truck = Object.assign({}, this.defaultTruck);
            if (this.$refs.form) this.$refs.form.resetValidation();
            // Update clocks
            this.clock.start = "09:00";
            this.clock.end = "17:00";
            // Initialize week days
            for (let i = 0; i < this.truck.week.length; i += 1) {
                this.truck.week[i].value = false;
            }
            // New item mode
            this.editedIndex = -1;
            this.dialog = true;
        },
        async save() {
            if (!this.isFilled || !this.isInputValid) {
                this.$refs.form.validate();
                return;
            }

            this.truck.arrival_time_from = this.clock.start;
            this.truck.arrival_time_to = this.clock.end;

            const data = Object.assign(this.truck);
            // API days format
            for (let i = 0; i < 7; i += 1) {
                data[this.apiDays[i]] = +this.truck.week[i].value;
            }
            if (this.truck.week.every(day => !day.value)) {
                this.$store.commit({
                    type: "alert",
                    text: "Please choose at least one day",
                    color: "error",
                    icon: "mdi-calendar-check",
                });
                return;
            }
            data.user_id = this.$store.getters.getLoggedUserID;
            // data.type = this.types.indexOf(this.truck.type) * 5 + 5;

            // Check if transporter name already exists
            const matchTransporter = transporter => {
                const compareCaseInsensitive =
                    transporter.name.toLowerCase() ===
                    this.truck.transp_name.toLowerCase();
                return compareCaseInsensitive;
            };
            const foundTransporter = this.transporters.find(matchTransporter);
            if (foundTransporter) {
                data.transporter_id = foundTransporter.id;
            } else {
                const response = await this.$store.dispatch("addTransporter", {
                    name: this.truck.transp_name,
                });
                data.transporter_id = response.id;
            }

            if (this.editedIndex > -1) {
                this.$store.dispatch("editRecRegistrations", data);
            } else {
                this.$store.dispatch("addRecRegistrations", data);
            }

            this.dialog = false;
        },

        addDay(day) {
            const dayFound = this.truck.week.find(d => d.day === day.day);
            if (dayFound) dayFound.value = !dayFound.value;
        },
        toggleClockStart() {
            this.clock.toggleStart = !this.clock.toggleStart;
            if (this.$refs.timerStart)
                this.$refs.timerStart.selectingHour = true;
        },
        toggleClockEnd() {
            this.clock.toggleEnd = !this.clock.toggleEnd;
            if (this.$refs.timerEnd) this.$refs.timerEnd.selectingHour = true;
        },
        rec_days(item) {
            let day;
            let numberOfDays = 0; // initialize number of all true days
            let count = 0; // intitialize count
            let longestSeq = 0; // initialize max
            let lastIndex = 0; // store the index of longest seq
            const daysOutput = [];
            const week = [
                { day: this.$t("message.Monday"), value: false },
                { day: this.$t("message.Tuesday"), value: false },
                { day: this.$t("message.Wednesday"), value: false },
                { day: this.$t("message.Thursday"), value: false },
                { day: this.$t("message.Friday"), value: false },
                { day: this.$t("message.Saturday"), value: false },
                { day: this.$t("message.Sunday"), value: false },
            ];

            week[0].value = item.on_monday;
            week[1].value = item.on_tuesday;
            week[2].value = item.on_wednesday;
            week[3].value = item.on_thursday;
            week[4].value = item.on_friday;
            week[5].value = item.on_saturday;
            week[6].value = item.on_sunday;

            for (day of week) numberOfDays += day.value;
            if (week.every(d => d.value === 1))
                return this.$t("message.EveryDay");
            for (let i = 0; i < week.length; i += 1) {
                // Reset count when 0 is found
                if (week[i].value === false) count = 0;
                else {
                    count += 1; // increase count
                    longestSeq = Math.max(longestSeq, count);
                    lastIndex = i;
                }
            }
            // Check for period
            if (longestSeq > 2 && longestSeq === numberOfDays) {
                return `${week[lastIndex - longestSeq + 1].day.slice(
                    0,
                    3
                )} - ${week[lastIndex].day.slice(0, 3)}`;
            }
            for (day of week)
                if (day.value) daysOutput.push(day.day.slice(0, 3));
            return daysOutput.join(", ");
        },
    },
    computed: {
        fab_color() {
            return this.dayStatus == null ? "primary" : "error darken-1";
        },
        get_day_label() {
            if (this.dayStatus === null) return "";
            return `for ${this.$t(
                `message.${this.truck.week[this.dayStatus].day}`
            )}`;
        },
        transporters() {
            return [...this.$store.getters.getTransporter].sort((a, b) => {
                if (a.name < b.name) return -1;
                return Number(a.name > b.name);
            });
        },
        items() {
            if (this.dayStatus === null) {
                return this.$store.getters.getRecRegistrations;
            }
            return this.$store.getters.getRecRegistrations.filter(
                recReg => recReg[this.apiDays[this.dayStatus]]
            );
        },
        rules() {
            return {
                required: value => !!value || this.$t("message.FieldRequired"),
                firstChar: value => {
                    const error = this.$t("message.FirstCharTransporter");
                    return (
                        (value && /^[A-Z-0-9]*$/.test(value.charAt(0))) || error
                    );
                },
                contactAllowedCharacters: value => {
                    const error = this.$t("message.SpecialCharacters");
                    return /^([a-zA-Z0-9. _-]*)$/.test(value) || error;
                },
                transporterAllowedCharacters: value => {
                    const error = this.$t("message.SpecialCharacters");
                    return /^([a-zA-Z0-9. /()_-]+)$/.test(value) || error;
                },
                email: value => {
                    const error = this.$t("message.InvalidEmail");
                    const pattern =
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || error;
                },
                max44Chars: value => {
                    const error = this.$t("message.Max44Chars");
                    return value.length <= 44 || error;
                },
                max63Chars: value => {
                    const error = this.$t("message.Max63Chars");
                    return !value || value.length <= 63 || error;
                },
                max127Chars: value => {
                    const error = this.$t("message.Max127Chars");
                    return !value || value.length < 128 || error;
                },
            };
        },
        formTitle() {
            return this.editedIndex === -1
                ? this.$t("message.NewRecRegistration")
                : this.$t("message.EditRecRegistration");
        },
        tableHeaders() {
            return [
                {
                    text: this.$t("message.Days"),
                    value: "days",
                    sortable: false,
                },
                {
                    text: this.$t("message.Time"),
                    value: "arrival_time_from",
                    sortable: true,
                },
                {
                    text: this.$t("message.Type"),
                    value: "type",
                    sortable: true,
                },
                {
                    text: this.$t("message.Transporter"),
                    value: "transp_name",
                    sortable: true,
                },
                {
                    text: this.$t("message.Reference"),
                    value: "reference",
                    sortable: true,
                },

                {
                    text: this.$t("message.Actions"),
                    value: "actions",
                    sortable: false,
                    hidden:
                        !this.$can("update", "recurringregistrations") &&
                        !this.$can("delete", "recurringregistrations"),
                },
            ].filter(title => !title.hidden);
        },
        formHeaders() {
            return [
                {
                    text: this.$t("message.Company"),
                    value: "company",
                },
                {
                    text: this.$t("message.Email"),
                    value: "email",
                },
                {
                    text: this.$t("message.Reference"),
                    value: "reference",
                },
                {
                    text: this.$t("message.ContactPerson"),
                    value: "contact",
                },
                {
                    text: this.$t("message.weekDaysTitle"),
                    value: "weekDays",
                },
                {
                    text: this.$t("message.ArrivalTimeFrom"),
                    value: "arrival_time_from",
                },
                {
                    text: this.$t("message.ArrivalTimeTo"),
                    value: "arrival_time_to",
                },
                {
                    text: this.$t("message.Transporter"),
                    value: "transporter",
                },
                {
                    text: this.$t("message.Type"),
                    value: "type",
                },
                {
                    text: this.$t("message.CustomerRemarks"),
                    value: "remarks_customer",
                },
            ];
        },
        isFilled() {
            return (
                !!this.truck.notification_email &&
                !!this.truck.reference &&
                !!this.truck.transp_name &&
                !!this.truck.type
            );
        },
        isInputValid() {
            return !(
                this.rules.contactAllowedCharacters(this.truck.contact) ===
                    this.$t("message.SpecialCharacters") ||
                this.rules.transporterAllowedCharacters(
                    this.truck.transp_name
                ) === this.$t("message.SpecialCharacters") ||
                this.rules.email(this.truck.notification_email) ===
                    this.$t("message.InvalidEmail") ||
                this.rules.max44Chars(this.truck.transp_name) ===
                    this.$t("message.Max44Chars") ||
                this.rules.max63Chars(this.truck.notification_email) ===
                    this.$t("message.Max63Chars") ||
                this.rules.max63Chars(this.truck.contact) ===
                    this.$t("message.Max63Chars") ||
                this.rules.max127Chars(this.truck.reference) ===
                    this.$t("message.Max127Chars") ||
                this.rules.max127Chars(this.truck.remarks_customer) ===
                    this.$t("message.Max127Chars")
            );
        },
    },
    watch: {
        clock: {
            handler() {
                this.changed = true;
            },
            deep: true,
        },
        truck: {
            handler() {
                this.changed = true;
            },
            deep: true,
        },
        dialog(val) {
            if (val) {
                this.changed = false;
                this.setFocus();
            }
        },
        lookup() {
            // Check for rule (capital letter or number)
            this.firstCharCorrect =
                this.lookup && /^[A-Z-0-9]*$/.test(this.lookup.charAt(0));
        },
    },
};
</script>
